import {
  Component,
  ChangeDetectionStrategy,
  input,
  output,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-checkbox-group-no-label',
  templateUrl: './checkbox-group-no-label.component.html',
  styleUrls: ['./checkbox-group-no-label.component.scss'],
  imports: [MatIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxGroupNoLabelComponent {
  /** Checkbox option (required) */
  option = input<{ key: string; value: string }>();

  /** Parent FormGroup containing the control (required) */
  parentForm = input<FormGroup>();

  /** The name of the form array group (required) */
  formArrayGroupName = input<string>();

  /** Set whether checkboxes are disabled (optional, default: false) */
  isDisabled = input<boolean>(false);

  /** Emitted when checkbox clicked */
  checkboxClicked = output<Event>();

  /** Gets the value of the checkbox's corresponding form control. */
  getChecked(): boolean | null {
    const controlAccessor = this.formArrayGroupName().toString();
    const arrayKey = 'controls';
    const arrayIndex = Number(this.option().value);
    return this.parentForm()?.controls?.[controlAccessor]?.[arrayKey]?.[
      arrayIndex
    ]?.value as boolean;
  }

  /** The click event to be emitted */
  updateValue(event: Event): void {
    this.checkboxClicked.emit(event);
  }
}
